// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cd7O5CruOgZv8ugTxAUW{align-items:center;gap:8px;padding-top:10px;padding-bottom:10px;display:flex}.nPLLvPPfYzTrspJbnmE2{gap:4px;display:flex}.v_Ua3bzvGEBMVK7jHeoN{pointer-events:none;opacity:.5}.k6vE0owrZjApCGcJ7MCU{flex-direction:column;gap:2px;display:flex}.wQm5FLdS9QDocrZNjiJ5{align-items:center;display:flex}.qVZ0CyNFc9Q81Dh6AYuN{color:var(--content-primary-tertiary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"numberCell": `cd7O5CruOgZv8ugTxAUW`,
	"row": `nPLLvPPfYzTrspJbnmE2`,
	"statusCell__block": `v_Ua3bzvGEBMVK7jHeoN`,
	"statusCellBlock": `v_Ua3bzvGEBMVK7jHeoN`,
	"content": `k6vE0owrZjApCGcJ7MCU`,
	"lock": `wQm5FLdS9QDocrZNjiJ5`,
	"lock__icon": `qVZ0CyNFc9Q81Dh6AYuN`,
	"lockIcon": `qVZ0CyNFc9Q81Dh6AYuN`
};
export default ___CSS_LOADER_EXPORT___;
